import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import HomeIcon from "@mui/icons-material/Home";

export default function LogoMain() {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <HomeIcon fontSize="large" color="primary" />
      <Typography variant="h5" color="text.primary" fontWeight={700}>
        HomeHunter
      </Typography>
    </Box>
  );
}
